/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Annotation from 'solis/claude/primitive/label/annotation';
import Countdown from 'solis/claude/element/countdown';


export default ({ zoneTimeline, previousDate, mark }) =>
{
  const date = zoneTimeline.getFlipDate();

  return (!previousDate && date) ? <Annotation mark = {mark}><Countdown date = {date} compact /></Annotation> : null;
};
